import React from "react";
import { useTranslation } from "react-i18next";
import { TertiaryButton } from "@dev/ee-components";
import { ViewButtonComponentProps } from "./types";
import { OpenInNewIconBlue } from "./styles";


export const ViewButtonComponent = (props: ViewButtonComponentProps): JSX.Element => {
    const { t } = useTranslation();
    const { landingPage } = props;

    const isDisabled = !landingPage.LandingUrl;
    const handleClick = (): void => {
        window.open(landingPage.LandingUrl, '_blank');
    }

    return (
        <TertiaryButton
            text={t('view')}
            disabled={isDisabled}
            onClick={handleClick}
            startIcon={<OpenInNewIconBlue $isDisabled={isDisabled} />}
        />
    )
}
